/**
 * Application entry point
 * Initializes React application and registers service worker for PWA functionality
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { GoogleOAuthProvider } from '@react-oauth/google';

// ── PostHog — initialise before the React tree mounts ────────────────────────
// Only activates when REACT_APP_POSTHOG_KEY is set (safe to omit in local dev).
const POSTHOG_KEY  = process.env.REACT_APP_POSTHOG_KEY;
const POSTHOG_HOST = process.env.REACT_APP_POSTHOG_HOST || 'https://us.i.posthog.com';

if (POSTHOG_KEY) {
  import('posthog-js').then(({ default: posthog }) => {
    posthog.init(POSTHOG_KEY, {
      api_host:                    POSTHOG_HOST,
      capture_pageview:            true,   // auto track every route change
      capture_pageleave:           true,
      autocapture:                 false,  // explicit events only — keeps data clean
      persistence:                 'localStorage',
      disable_session_recording:   true,   // enable in PostHog UI when ready
    });
    // Expose on window so useAnalytics hook can reach it without prop drilling
    window.posthog = posthog;
  }).catch(() => {/* PostHog load failure is non-fatal */});
}

// Create root and render the App component
const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <App />
    </GoogleOAuthProvider>
  </React.StrictMode>
);

// Unregister any cached service workers so users always get the latest build
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(registrations => {
    registrations.forEach(registration => registration.unregister());
  });
}
